module.exports = __webpack_public_path__ + "img/qianming.cc4c171d.png";